<template>
  <div class="asset-bulk-actions-container">
    <ul class="menu submenu is-dropdown-submenu first-sub vertical showActionMenu" v-if="hasAccess">
      <li
        v-if="currentUser.permissions.can_write_attachments_product_associations"
        class="is-submenu-item is-dropdown-submenu-item actionSubMenuTrigger actionAddProductTrigger"
      >
        <a @click="selectAction('addToProductModal')">Add/Modify Product</a>
      </li>
      <li
        v-if="currentUser.permissions.can_delete_attachments"
        class="is-submenu-item is-dropdown-submenu-item actionSubMenuTrigger actionDeleteTrigger"
      >
        <a @click="selectAction('deleteModal')">Delete Selected</a>
      </li>
      <li
        v-if="currentUser.permissions.can_write_attachments"
        class="is-submenu-item is-dropdown-submenu-item actionSubMenuTrigger actionBatchUploadTrigger"
      >
        <a @click="selectAction('batchUploadModal')">Batch Upload</a>
      </li>
      <li
        v-if="currentUser.permissions.can_write_attachments"
        class="is-submenu-item is-dropdown-submenu-item actionSubMenuTrigger actionBatchChangeContentSourceTrigger"
      >
        <a @click="selectAction('contentSourceModal')">Change Content Source</a>
      </li>
      <li
        v-if="currentUser.permissions.can_write_attachments"
        class="is-submenu-item is-dropdown-submenu-item actionSubMenuTrigger actionBatchAddTagTrigger"
      >
        <a @click="selectAction('addTagsModal')">Add Tags</a>
      </li>
      <li
        v-if="currentUser.permissions.can_write_attachments"
        class="is-submenu-item is-dropdown-submenu-item actionSubMenuTrigger actionBatchRemoveTagTrigger"
      >
        <a @click="selectAction('removeTagsModal')">Remove Tags</a>
      </li>
      <li
        v-if="currentUser.permissions.can_write_attachments"
        class="is-submenu-item is-dropdown-submenu-item actionSubMenuTrigger actionBatchRevisedDateTrigger"
      >
        <a @click="selectAction('revisedDateModal')">Update Revised Date</a>
      </li>
    </ul>
    <add-to-product-modal v-if="selectedAction == 'addToProductModal'"  @closed="closedModal" />
    <delete-modal v-if="selectedAction == 'deleteModal'" @closed="closedModal" />
    <batch-upload-modal v-if="selectedAction == 'batchUploadModal'" />
    <change-content-source-modal v-if="selectedAction == 'contentSourceModal'"  @closed="closedModal" />
    <add-tag-modal v-if="selectedAction == 'addTagsModal'"  @closed="closedModal" />
    <remove-tag-modal v-if="selectedAction == 'removeTagsModal'"  @closed="closedModal" />
    <change-revised-date-modal v-if="selectedAction == 'revisedDateModal'"  @closed="closedModal" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddToProductModal from '../shared/bulk_actions/AddToProductModal.vue'
import ChangeContentSourceModal from '../shared/bulk_actions/ChangeContentSourceModal.vue'
import DeleteModal from '../shared/bulk_actions/DeleteAssetsModal.vue'
import BatchUploadModal from './BatchUploadModal.vue'
import BulkActionsMixin from '@/mixins/bulk-actions.js'
import AddTagModal from '../shared/bulk_actions/AddTagModal.vue'
import RemoveTagModal from '../shared/bulk_actions/RemoveTagModal.vue'
import ChangeRevisedDateModal from '../shared/bulk_actions/ChangeRevisedDateModal.vue'

export default {
  components: {
    AddToProductModal,
    DeleteModal,
    BatchUploadModal,
    ChangeContentSourceModal,
    AddTagModal,
    RemoveTagModal,
    ChangeRevisedDateModal
  },
  mixins: [BulkActionsMixin],
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    hasAccess () {
      return this.currentUser.permissions.can_write_attachments_product_associations ||
              this.currentUser.permissions.can_write_attachments ||
              this.currentUser.permissions.can_delete_attachments
    }
  }
}
</script>

<style lang="scss" scoped>
.is-dropdown-submenu {
  width: 250px;
}
</style>
